const apis = {
  announcementList: async (params = false) => { return await axios.get('/api/announcement', {params}) },
  announcementGet: async (id) => { return await axios.get(`/api/announcement/${id}`) },
  announcementStore: async (form) => { return await axios.post('/api/announcement', form) },
  announcementUpdate: async (id, form) => { return await axios.put(`/api/announcement/${id}`, form) },
  announcementDelete: async (id) => { return await axios.delete(`/api/announcement/${id}`) },

  branchList: async (params = false) => { return await axios.get('/api/branch', {params}) },
  branchGet: async (id) => { return await axios.get(`/api/branch/${id}`) },
  branchStore: async (form) => { return await axios.post('/api/branch', form) },
  branchUpdate: async (id, form) => { return await axios.put(`/api/branch/${id}`, form) },
  branchDelete: async (id) => { return await axios.delete(`/api/branch/${id}`) },

  calendarEventList: async (params = false) => { return await axios.get('/api/calendarEvent', {params}) },
  calendarEventGet: async (id) => { return await axios.get(`/api/calendarEvent/${id}`) },
  calendarEventStore: async (form) => { return await axios.post('/api/calendarEvent', form) },
  calendarEventUpdate: async (id, form) => { return await axios.put(`/api/calendarEvent/${id}`, form) },
  calendarEventDelete: async (id) => { return await axios.delete(`/api/calendarEvent/${id}`) },

  customerEventTypeList: async (params = false) => { return await axios.get('/api/customerEventType', {params}) },
  customerEventTypeGet: async (id) => { return await axios.get(`/api/customerEventType/${id}`) },
  customerEventTypeStore: async (form) => { return await axios.post('/api/customerEventType', form) },
  customerEventTypeUpdate: async (id, form) => { return await axios.put(`/api/customerEventType/${id}`, form) },
  customerEventTypeDelete: async (id) => { return await axios.delete(`/api/customerEventType/${id}`) },

  customerLevelList: async (params = false) => { return await axios.get('/api/customerLevel', {params}) },
  customerLevelGet: async (id) => { return await axios.get(`/api/customerLevel/${id}`) },
  customerLevelStore: async (form) => { return await axios.post('/api/customerLevel', form) },
  customerLevelUpdate: async (id, form) => { return await axios.put(`/api/customerLevel/${id}`, form) },
  customerLevelDelete: async (id) => { return await axios.delete(`/api/customerLevel/${id}`) },

  customFieldList: async (params = false) => { return await axios.get('/api/customField', {params}) },
  customFieldGet: async (id) => { return await axios.get(`/api/customField/${id}`) },
  customFieldStore: async (form) => { return await axios.post('/api/customField', form) },
  customFieldUpdate: async (id, form) => { return await axios.put(`/api/customField/${id}`, form) },
  customFieldDelete: async (id) => { return await axios.delete(`/api/customField/${id}`) },

  departmentList: async (params = false) => { return await axios.get('/api/department', {params}) },
  departmentGet: async (id) => { return await axios.get(`/api/department/${id}`) },
  departmentStore: async (form) => { return await axios.post('/api/department', form) },
  departmentUpdate: async (id, form) => { return await axios.put(`/api/department/${id}`, form) },
  departmentDelete: async (id) => { return await axios.delete(`/api/department/${id}`) },

  fileList: async (params = false) => { return await axios.get('/api/file', {params}) },
  fileGet: async (id, params = false) => { return await axios.get(`/api/file/${id}`, {params}) },
  fileStore: async (form) => { return await axios.post('/api/file', form) },
  fileUpdate: async (id, form) => { return await axios.put(`/api/file/${id}`, form) },
  fileDelete: async (id) => { return await axios.delete(`/api/file/${id}`) },

  formList: async (params = false) => { return await axios.get('/api/form', {params}) },
  formGet: async (id) => { return await axios.get(`/api/form/${id}`) },
  formStore: async (form) => { return await axios.post('/api/form', form) },
  formUpdate: async (id, form) => { return await axios.put(`/api/form/${id}`, form) },
  formDelete: async (id) => { return await axios.delete(`/api/form/${id}`) },

  knowledgebaseArticleList: async (params = false) => { return await axios.get('/api/knowledgebaseArticle', {params}) },
  knowledgebaseArticleGet: async (id) => { return await axios.get(`/api/knowledgebaseArticle/${id}`) },
  knowledgebaseArticleStore: async (form = false) => { return await axios.post('/api/knowledgebaseArticle', form) },
  knowledgebaseArticleUpdate: async (id, form) => { return await axios.put(`/api/knowledgebaseArticle/${id}`, form) },
  knowledgebaseArticleDelete: async (id) => { return await axios.delete(`/api/knowledgebaseArticle/${id}`) },

  knowledgebaseCategoryList: async (params = false) => { return await axios.get('/api/knowledgebaseCategory', {params}) },
  knowledgebaseCategoryGet: async (id) => { return await axios.get(`/api/knowledgebaseCategory/${id}`) },
  knowledgebaseCategoryStore: async (form) => { return await axios.post('/api/knowledgebaseCategory', form) },
  knowledgebaseCategoryUpdate: async (id, form) => { return await axios.post(`/api/knowledgebaseCategory/${id}`, form) },
  knowledgebaseCategoryDelete: async (id) => { return await axios.delete(`/api/knowledgebaseCategory/${id}`) },

  knowledgebaseTemplateList: async (params = false) => { return await axios.get('/api/knowledgebaseTemplate', {params}) },
  knowledgebaseTemplateGet: async (id) => { return await axios.get(`/api/knowledgebaseTemplate/${id}`) },
  knowledgebaseTemplateStore: async (form) => { return await axios.post('/api/knowledgebaseTemplate', form) },
  knowledgebaseTemplateUpdate: async (id, form) => { return await axios.put(`/api/knowledgebaseTemplate/${id}`, form) },
  knowledgebaseTemplateDelete: async (id) => { return await axios.delete(`/api/knowledgebaseTemplate/${id}`) },

  organizationList: async (params = false) => { return await axios.get('/api/organization', {params}) },
  organizationGet: async (id) => { return await axios.get(`/api/organization/${id}`) },
  organizationStore: async (form) => { return await axios.post('/api/organization', form) },
  organizationUpdate: async (id, form) => { return await axios.put(`/api/organization/${id}`, form) },
  organizationDelete: async (id) => { return await axios.delete(`/api/organization/${id}`) },

  serviceList: async (params = false) => { return await axios.get('/api/service', {params}) },
  serviceGet: async (id) => { return await axios.get(`/api/service/${id}`) },
  serviceStore: async (form) => { return await axios.post('/api/service', form) },
  serviceUpdate: async (id, form) => { return await axios.put(`/api/service/${id}`, form) },
  serviceDelete: async (id) => { return await axios.delete(`/api/service/${id}`) },

  slaList: async (params = false) => { return await axios.get('/api/sla', {params}) },
  slaGet: async (id) => { return await axios.get(`/api/sla/${id}`) },
  slaStore: async (form) => { return await axios.post('/api/sla', form) },
  slaUpdate: async (id, form) => { return await axios.put(`/api/sla/${id}`, form) },
  slaDelete: async (id) => { return await axios.delete(`/api/sla/${id}`) },

  tagList: async (params = false) => { return await axios.get('/api/tag', {params}) },
  tagStore: async (form) => { return await axios.post('/api/tag', form) },
  tagDelete: async (id) => { return await axios.delete(`/api/tag/${id}`) },

  ticketList: async (params = false) => { return await axios.get('/api/ticket', {params}) },
  ticketGet: async (id) => { return await axios.get(`/api/ticket/${id}`) },
  ticketStore: async (form) => { return await axios.post('/api/ticket', form) },
  ticketUpdate: async (id, form) => { return await axios.post(`/api/ticket/${id}`, form) },
  ticketDelete: async (id) => { return await axios.delete(`/api/ticket/${id}`) },

  ticketCategoryList: async (params = false) => { return await axios.get('/api/ticketCategory', {params}) },
  ticketCategoryGet: async (id) => { return await axios.get(`/api/ticketCategory/${id}`) },
  ticketCategoryStore: async (form) => { return await axios.post('/api/ticketCategory', form) },
  ticketCategoryUpdate: async (id, form) => { return await axios.put(`/api/ticketCategory/${id}`, form) },
  ticketCategoryDelete: async (id) => { return await axios.delete(`/api/ticketCategory/${id}`) },

  ticketFormList: async (params = false) => { return await axios.get('/api/ticketForm', {params}) },
  ticketFormGet: async (id) => { return await axios.get(`/api/ticketForm/${id}`) },
  ticketFormStore: async (ticketForm) => { return await axios.post('/api/ticketForm', ticketForm) },
  ticketFormUpdate: async (id, ticketForm) => { return await axios.put(`/api/ticketForm/${id}`, ticketForm) },
  ticketFormDelete: async (id) => { return await axios.delete(`/api/ticketForm/${id}`) },

  ticketTemplateList: async (params = false) => { return await axios.get('/api/ticketTemplate', {params}) },
  ticketTemplateGet: async (id) => { return await axios.get(`/api/ticketTemplate/${id}`) },
  ticketTemplateStore: async (form) => { return await axios.post('/api/ticketTemplate', form) },
  ticketTemplateUpdate: async (id, form) => { return await axios.put(`/api/ticketTemplate/${id}`, form) },
  ticketTemplateDelete: async (id) => { return await axios.delete(`/api/ticketTemplate/${id}`) },

  todoList: async (params = false) => { return await axios.get('/api/todo', {params}) },
  todoStore: async (form) => { return await axios.post('/api/todo', form) },
  todoUpdate: async (id, form) => { return await axios.put(`/api/todo/${id}`, form) },
  todoDelete: async (id) => { return await axios.delete(`/api/todo/${id}`) },

  userList: async (params = false) => { return await axios.get('/api/user', { params }) },
  userGet: async (id, employee) => { return await axios.get(`/api/user/${id}?employee=${employee}`) },
  userStore: async (form) => { return await axios.post('/api/user', form) },
  userUpdate: async (id, form) => { return await axios.put(`/api/user/${id}`, form) },
  userDelete: async (id, employee) => { return await axios.delete(`/api/user/${id}?employee=${employee}`) },

  workingShiftList: async (params = false) => { return await axios.get('/api/workingshift', {params}) },
  workingShiftGet: async (id) => { return await axios.get(`/api/workingshift/${id}`) },
  workingShiftStore: async (form) => { return await axios.post('/api/workingshift', form) },
  workingShiftUpdate: async (id, form) => { return await axios.put(`/api/workingshift/${id}`, form) },
  workingShiftDelete: async (id) => { return await axios.delete(`/api/workingshift/${id}`) },


  login: async (form) => { return await axios.post('/api/login', form) },
  logout: async () => { return await axios.post('/api/logout') },
  me: async () => { return await axios.get('/api/me') },
  checkUsername: async (form) => { return await axios.post('/api/checkUsername', form) },
  passwordReset: async (form) => { return await axios.post('/api/passwordReset', form) },
  passwordResetToken: async (form) => { return await axios.post('/api/passwordResetToken', form) },
  register: async (form) => { return await axios.post('/api/register', form) },
  updateProfile: async (form) => { return await axios.post('/api/updateProfile', form) },
  verifyAccount: async (form) => { return await axios.post('/api/verifyAccount', form) },


  adminDefaults: async () => { return await axios.get('/api/adminDefaults') },
  downloadAttachment: async (id) => { return await axios.get(`/api/attachment/${id}`, {withoutInterceptor: true, responseType: 'blob'}) },
  checkDefaultReciever: async (params = false) => { return await axios.get('/api/checkDefaultReciever', {params}) },
  cities: async () => { return await axios.get(`/api/cities`) },
  getCallHistory: async (params = false) => { return await axios.get(`/api/callHistory`, {params}) },
  countries: async () => { return await axios.get(`/api/countries`) },
  customerCustomFieldList: async () => { return await axios.get('/api/customerCustomField') },
  customerCustomFieldUpdate: async (form) => { return await axios.put('/api/customerCustomField', form) },
  customerEventList: async (params = false) => { return await axios.get('/api/customerEvent', {params}) },
  customerEventStore: async (form) => { return await axios.post('/api/customerEvent', form) },
  customerEventDelete: async (id) => { return await axios.delete(`/api/customerEvent/${id}`) },
  defaultSettings: async (params = false) => { return await axios.get('/api/defaultSettings', {params}) },
  deleteTicketContent: async (ticket_content_id) => { return await axios.delete('/api/deleteTicketContent', {params: {ticket_content_id}}) },
  deleteDoneTodos: async () => { return await axios.delete('/api/deleteDoneTodos') },
  importUsers: async (formData) => { return await axios.post('/api/importUsers', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) },
  getLogs: async (params = false) => { return await axios.get(`/api/log`, {params}) },
  makeCall: async (form) => { return await axios.post(`/api/makeCall`, form) },
  multipleDelete: async (type, type_ids) => { return await axios.delete('/api/multipleDelete', { params: { type, type_ids } }) },
  multipleTicketAction: async (form) => { return await axios.put('/api/multipleTicketAction', form) },
  getOrder: async (type) => { return await axios.get('/api/order', { params: { type } }) },
  updateOrder: async (type, type_ids) => { return await axios.put('/api/order', { type, type_ids }) },
  organizationCustomFieldList: async () => { return await axios.get('/api/organizationCustomField') },
  organizationCustomFieldUpdate: async (form) => { return await axios.put('/api/organizationCustomField', form) },
  satisfaction: async (form) => { return await axios.put('/api/satisfaction', form) },
  getSettings: async () => { return await axios.get('/api/settings') },
  updateSettings: async (form) => { return await axios.post('/api/settings', form) },
  states: async () => { return await axios.get(`/api/states`) },
  systemDefaults: async () => { return await axios.get('/api/systemDefaults') },
  systemSettings: async () => { return await axios.get('/api/systemSettings') },
  assignTag: async (id, form) => { return await axios.post(`/api/tagAction/${id}`, form) },
  removeTag: async (id, form) => { return await axios.delete(`/api/tagAction/${id}`, { data: form }) },
  testEmail: async (email) => { return await axios.post('/api/testEmail', { email: email }) },
  testSMS: async (number) => { return await axios.post('/api/testSms', { number: number }) },
  testWebhook: async () => { return await axios.post('/api/testWebhook') },
  userAnnouncements: async (params = false) => { return await axios.get('/api/userAnnouncements', {params}) },
  userNotifications: async (params = false) => { return await axios.get('/api/userNotifications', {params}) },


  kbCategoryList: async (params = false) => { return await axios.get('/api/kbCategory', {params}) },
  kbArticleList: async (params = false) => { return await axios.get(`/api/kbArticle`, {params}) },
  kbArticleGet: async (slug) => { return await axios.get(`/api/kbArticle/${slug}`) },
  kbArticleUpdate: async (slug, form) => { return await axios.put(`/api/kbArticle/${slug}`, form) },


  reportImportanceTicket: async (params = false) => { return await axios.get('/api/reportImportanceTicket', {params}) },
  reportSatisfactionEmployee: async (params = false) => { return await axios.get('/api/reportSatisfactionEmployee', {params}) },
  reportSatisfactionTicket: async (params = false) => { return await axios.get('/api/reportSatisfactionTicket', {params}) },
  reportServiceTicket: async (params = false) => { return await axios.get('/api/reportServiceTicket', {params}) },
  reportServiceUser: async (params = false) => { return await axios.get('/api/reportServiceUser', {params}) },
  reportSlaTicket: async (params = false) => { return await axios.get('/api/reportSlaTicket', {params}) },
  reportTagUserTicket: async (params = false) => { return await axios.get('/api/reportTagUserTicket', {params}) },
  reportTicketCategoryTicket: async (params = false) => { return await axios.get('/api/reportTicketCategoryTicket', {params}) },
  reportTicketFrequency: async (params = false) => { return await axios.get('/api/reportTicketFrequency', {params}) },
  reportTicketState: async (params = false) => { return await axios.get('/api/reportTicketState', {params}) },
  reportTicketStatusTicket: async (params = false) => { return await axios.get('/api/reportTicketStatusTicket', {params}) },
}

export const useApi = () => {
  return apis;
}

export default {
  install: async (app) => {
    for (const key in apis) {
      app.config.globalProperties[`$${key}`] = apis[key];
      app.provide(key, apis[key]);
    }
  }
}
